import { render, staticRenderFns } from "./PerformanceCloseoutDetails.vue?vue&type=template&id=47c83468&scoped=true"
import script from "./PerformanceCloseoutDetails.vue?vue&type=script&lang=js"
export * from "./PerformanceCloseoutDetails.vue?vue&type=script&lang=js"
import style0 from "./PerformanceCloseoutDetails.vue?vue&type=style&index=0&id=47c83468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c83468",
  null
  
)

export default component.exports